import React, { Suspense } from 'react';
import logo from './logo.svg';
import './App.css';
import AxiosErrorInterceptor from './components/axiosInterceptors';
import {  HashRouter, Route, BrowserRouter, Switch } from 'react-router-dom';
import { useMultipleInjection } from './di/ioc-provider';
import { IRoute } from './routing/routeInterface';
import { TYPES } from './di/types';
import { JsStillRendering } from './components/jsStillRendering';
require("./promiseExtension");
export const  App = () =>  {
  const _routes = useMultipleInjection<IRoute>(TYPES.IRoute);
  return <><AxiosErrorInterceptor />
    <BrowserRouter>
      <Suspense fallback={<JsStillRendering />}>
        <Switch>
          {_routes.map((el) => { return el.registerRoute() })}
        </Switch>
      </Suspense>
    </BrowserRouter>
  </>
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
